import { useQuery } from '@apollo/client/react';

import { gql } from 'src/__generated__';
import type {
  GetProfileVisibilityOptionsQuery,
  GetProfileVisibilityOptionsQueryVariables,
} from 'src/__generated__/graphql';
import { useConfig } from 'src/context/config';

export const GET_PROFILE_VISIBILITY_OPTIONS = gql(`
  query GetProfileVisibilityOptions($locale: Locale!, $zone: Zone!) {
    profileVisibilityOptions {
      id
      label: name(locale: $locale)
      description(locale: $locale, zone: $zone)
      __typename
    }
  }
`);

export const useProfileVisibilityOptions = () => {
  const {
    config: { VOCAB_LANGUAGE: locale, ZONE: zone },
  } = useConfig();
  const { data, loading, error } = useQuery<
    GetProfileVisibilityOptionsQuery,
    GetProfileVisibilityOptionsQueryVariables
  >(GET_PROFILE_VISIBILITY_OPTIONS, {
    variables: { locale, zone },
    fetchPolicy: 'cache-first',
  });

  return {
    options: data?.profileVisibilityOptions ?? [],
    loading,
    error,
  };
};
